import { Container, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import React, { useState } from 'react';
import VisibilitySensor from "react-visibility-sensor";
import CountUp from 'react-countup';

const CustomerDetails = () => {
  const [visible, setVisible] = useState(false);

  function onChange(isVisible) {
    if (isVisible) {
      setVisible(true);
    }
  }
  return (
    <div>
      <Container>
        <Grid container spacing={4} sx={{ my: 9 }}>
          <Grid item xs={12} md={3} sm={6} >
            <Box sx={{ backgroundColor: "#DFF6FF", p: 4, height: 220, boxShadow: "-4px -5px 14px rgb(0 0 0 / 8%), 5px 8px 16px rgb(0 0 0 / 8%)" }}>
              <i style={{ fontSize: '3em', color: "#2b7377" }} className="fas fa-eye"></i>
              <br />
              <VisibilitySensor onChange={onChange}>
                <CountUp
                  style={{ fontWeight: 'bold', color: 'white', fontSize: '3em' }}
                  start={0}
                  end={visible ? 15 : 0}
                  duration={3}
                  suffix="M"
                ></CountUp>
              </VisibilitySensor>
              <Typography variant='h6' style={{ color: "#2b7377", fontWeight: 'bold' }}>Total View</Typography>
            </Box>
          </Grid>
          <Grid
            item xs={12} md={3} sm={6} >
            <Box sx={{ backgroundColor: "#c2ebfb", p: 4, height: 220, boxShadow: "-4px -5px 14px rgb(0 0 0 / 8%), 5px 8px 16px rgb(0 0 0 / 8%)" }}>
              <i style={{ fontSize: '3em', color: "#2b7377" }} className="fas fa-users"></i>
              <br />
              <VisibilitySensor onChange={onChange}>
                <CountUp
                  style={{ fontWeight: 'bold', color: 'white', fontSize: '3em' }}
                  start={0}
                  end={visible ? 160 : 0}
                  duration={3}
                  suffix="K"
                ></CountUp>
              </VisibilitySensor>
              <Typography variant='h6' style={{ color: "#2b7377", fontWeight: 'bold' }}>Total User</Typography></Box>
          </Grid>
          <Grid item xs={12} md={3} sm={6} >
            <Box sx={{ backgroundColor: "#DFF6FF", p: 4, height: 220, boxShadow: "-4px -5px 14px rgb(0 0 0 / 8%), 5px 8px 16px rgb(0 0 0 / 8%)" }}>
              <i style={{ fontSize: '3em', color: "#2b7377" }} className="fa-solid fa-house"></i>
              <br />
              <VisibilitySensor onChange={onChange}>
                <CountUp
                  style={{ fontWeight: 'bold', color: 'white', fontSize: '3em' }}
                  start={0}
                  end={visible ? 12 : 0}
                  duration={3}
                  suffix="K"
                ></CountUp>
              </VisibilitySensor>
              <Typography variant='h6' style={{ color: "#2b7377", fontWeight: 'bold' }}>Total House Listed</Typography></Box>
          </Grid>
          <Grid item xs={12} md={3} sm={6}>
            <Box sx={{ backgroundColor: "#c2ebfb", p: 4, height: 220, boxShadow: "-4px -5px 14px rgb(0 0 0 / 8%), 5px 8px 16px rgb(0 0 0 / 8%)" }}>
              <i style={{ fontSize: '3em', color: "#2b7377" }} className="fa-solid fa-comment-dots"></i>
              <br />
              <VisibilitySensor onChange={onChange}>
                <CountUp
                  style={{ fontWeight: 'bold', color: 'white', fontSize: '3em' }}
                  start={0}
                  end={visible ? 18 : 0}
                  duration={3}
                  suffix="K"
                ></CountUp>
              </VisibilitySensor>
              <Typography variant='h6' style={{ color: "#2b7377", fontWeight: 'bold' }}>Total Rent Request</Typography></Box>
          </Grid>
        </Grid>
      </Container>
    </div >
  );
};

export default CustomerDetails;